import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

class OntarioPatientEnrollmentSectionContainer extends BaseReactComponent<{ title: string }, null> {
    public render(): JSX.Element {
        return (
            <div className="psingle-column wider centered">
                <div className="block separated">
                    <div className="flex-container heading">
                        <h3 className="h thin-font">{this.props.title}</h3>
                    </div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export { OntarioPatientEnrollmentSectionContainer };
